const presentedNewFrameIds = new Set<string>();
const MAX_PRESENTED_NEW_FRAME_IDS = 100;

/** Prevents the new-node auto-fit from racing a create-time presentation. */
export function suppressNextAutoFitForPresentedFrame(frameId: string): void {
  presentedNewFrameIds.add(frameId);
  while (presentedNewFrameIds.size > MAX_PRESENTED_NEW_FRAME_IDS) {
    const oldest = presentedNewFrameIds.values().next().value;
    if (typeof oldest !== "string") break;
    presentedNewFrameIds.delete(oldest);
  }
}

/** Consumes one-shot suppression for newly observed frame IDs. */
export function consumePresentedFrameAutoFitSuppression(
  frameIds: readonly string[],
): boolean {
  const hasPresentedFrame = frameIds.some((id) => presentedNewFrameIds.has(id));
  for (const id of frameIds) presentedNewFrameIds.delete(id);
  return hasPresentedFrame;
}
